const THREE = require('three')

import * as config from './config'
import {config as gameConfig} from '../config'
import _ from 'lodash'
require('src/lib/Maf')
import listener from '../listener'
import {TweenMax, Back, Elastic, Cubic} from 'gsap'
import sounds from '../sounds'
import scene from '../scene'
import * as colors from '../colors'

class Tile {

  constructor (tileId) {
    this.tileId = tileId
    this.tileType = config.types[tileId]
    this.mesh = new THREE.Object3D()
    this.mesh.name = tileId

    this.emojis = []
    this.emojiActive = false

    this.initObjects()
    this.initAudio()
    this.initTrees()
    this.initAirport()
    this.initPeople()
    this.initEmoji()

    this.hide()

    this.stopSound(0)
    return this
  }

  // **********************************************************************
  //
  // INIT
  //
  // **********************************************************************
  initObjects () {
    for (let key of this.tileType.objs) {
      let obj = config.objects[key]
      let geometry = obj.geometry

      let material
      if (config.textures[obj.texture]) {
        material = config.textures[obj.texture].material
        if (obj.cloneMaterial) {
          material = material.clone()
        }
      } else {
        material = new THREE.MeshPhongMaterial({transparent: true})
      }

      if (key === 'garage_start') {
        material = config.textures.stadium.material
        // material = new THREE.MeshStandardMaterial({
        //   metalness: 0.3,
        //   roughness: 0.3
        // })
      }


      let mesh = new THREE.Mesh(geometry, material)
      mesh.name = key
      if (obj.renderOrder) mesh.renderOrder = obj.renderOrder
      mesh.scale.setScalar(1)
      mesh.receiveShadow = true
      // mesh.castShadow = true
      this.mesh.add(mesh)

      // EXCEPTIONS
      switch (key) {
        case 'ticker_left':
        case 'ticker_right':
        case 'arrow_curve_left':
        case 'arrow_curve_right':
          mesh.scale.y = 0.75
          break
        case 'ribbon_left':
        case 'ribbon_right':
          mesh.position.y = -0.4
          break
        // case 'garage_start':
        //   let garageLight = new THREE.PointLight(colors.red.clone(), 0.8, 60)
        //   garageLight.name = `${key}-light`
        //   garageLight.position.set(22, 0, 0)
        //   mesh.add(garageLight)
        //   break
        case 'stadium_building':
          let stadiumLight = new THREE.PointLight(colors.white.clone(), 0.8, 70)
          stadiumLight.name = `${key}-light`
          stadiumLight.position.set(-19, 54, 0)
          mesh.add(stadiumLight)
          break
      }
    }
  }

  initAudio () {
    this.audio = {}
    for (let key in this.tileType.sounds) {
      let sound = this.tileType.sounds[key]
      for (let pos of sound) {
        let audio = new THREE.PositionalAudio(listener)
        audio.setBuffer(config.sounds[key].buffer)
        audio.setRefDistance(config.sounds[key].distance || 10)
        audio.setRolloffFactor(config.sounds[key].rollOff || 20)
        audio.setLoop(true)
        audio.setVolume(0.001)
        // console.log(pos)
        audio.position.set(pos.x, pos.y, pos.z)
        audio.play()
        this.audio[key] = audio
        this.mesh.add(audio)
      }
    }
  }

  initAirport () {
    if (!this.tileType.sprites.airport) return

    let positions = this.tileType.sprites.airport
    let material = config.textures.airport.material

    for (let posIdx = 0; posIdx < positions.length; posIdx++) {
      let pos = positions[posIdx]
      let mesh = new THREE.Sprite(material)
      mesh.position.set(pos[0], 0.5, pos[2])
      mesh.scale.setScalar(1)
      this.mesh.add(mesh)
    }
  }

  initTrees () {
    if (!this.tileType.sprites.tree) return

    let positions = this.tileType.sprites.tree
    positions = _.sampleSize(positions, Math.round(positions.length * 0.5))

    let material = config.textures.tree.material
    let geometry = new THREE.PlaneGeometry(1, 1)

    // MERGED GEOMETRY
    let mergedGeometry = new THREE.Geometry()
    let scaleConfig = config.textures.tree.scale
    for (let posIdx = 0; posIdx < positions.length; posIdx++) {
      let scale = window.Maf.randomInRange(scaleConfig.min, scaleConfig.max)
      let pos = positions[posIdx]
      let mesh = new THREE.Mesh(geometry, material)
      mesh.position.set(pos[0], scale / 2, pos[2])
      mesh.scale.setScalar(scale)
      mesh.updateMatrix()
      mergedGeometry.merge(mesh.geometry, mesh.matrix)
    }

    // MESH
    let mesh = new THREE.Mesh(mergedGeometry, material)
    this.mesh.add(mesh)
  }


  initPeople () {
    if (!this.tileType.sprites.people) return

    let positions = _.cloneDeep(this.tileType.sprites.people)

    // EXTRA PEOPLE FOR START N FINISH
    if (this.tileId === 'start' || this.tileId === 'finish') {
      positions = _.sampleSize(positions, Math.round(positions.length * 0.9))
    } else {
      positions = _.sampleSize(positions, Math.round(positions.length * 0.8))
    }

    positions = _.shuffle(positions)

    let geometry = new THREE.PlaneGeometry(1, 1)
    let materials = config.textures.people.materials
    let samplePercent
    if (this.tileId === 'start' || this.tileId === 'finish') {
      samplePercent = 0.8
    } else {
      samplePercent = 0.6
    }
    materials = _.sampleSize(materials, Math.round(materials.length * samplePercent))

    this.peoplePositions = []

    for (let material of materials) {

      let scaleConfig = config.textures.people.scale

      var numPos = Math.ceil(positions.length / materials.length / samplePercent)
      let pos = []
      for (let i = 0; i < numPos; i++) {
        let p = positions.pop()
        pos.push(p)
        this.peoplePositions.push(p)
      }

      // if (this.tileId === 'start') console.log(pos)

      // GEOMETRY
      let mergedGeometry = new THREE.Geometry()
      for (let posIdx = 0; posIdx < pos.length; posIdx++) {
        let scale = window.Maf.randomInRange(scaleConfig.min, scaleConfig.max)
        let p = pos[posIdx]
        let mesh = new THREE.Mesh(geometry, material)
        mesh.position.set(p[0], scale / 2 + p[1] + 0.2, p[2])
        mesh.scale.setScalar(scale)
        mesh.updateMatrix()
        mergedGeometry.merge(mesh.geometry, mesh.matrix)
      }

      // MESH
      let mesh = new THREE.Mesh(mergedGeometry, material)
      this.mesh.add(mesh)

    }

  }


  initEmoji = ()=> {

    if (!this.tileType.sprites.people) return

    let positions = this.peoplePositions

    let percent
    if (this.tileId === 'start' || this.tileId === 'finish') {
      percent = 0.15
    } else {
      percent = 0.25
    }
    positions = _.sampleSize(this.peoplePositions, Math.round(this.peoplePositions.length * percent))

    for (let posIdx = 0; posIdx < positions.length; posIdx++) {
      let material = _.sample(config.textures.emojis.materials)
      let pos = positions[posIdx]
      let mesh = new THREE.Sprite(material)
      mesh.position.set(pos[0], 5.2, pos[2])
      mesh.scale.setScalar(0)
      this.emojis.push(mesh)
      this.mesh.add(mesh)

      // PREPARE ANIM
      let s = window.Maf.randomInRange(2.7,3.2)
      mesh.tween = TweenMax.to(mesh.scale, 1, {
        x: s,
        y: s,
        z: s,
        ease: Elastic.easeOut,
        delay: 0.7 + Math.random(),
        paused: true
      })
    }
  }

  showEmojis = ()=> {
    if (this.emojiActive) return
    this.emojiActive = true
    for (let emoji of this.emojis) {
      emoji.tween.play()
    }
  }

  hideEmojis = ()=> {
    if (!this.emojiActive) return
    this.emojiActive = false
    for (let emoji of this.emojis) {
      emoji.scale.setScalar(0)
      // emoji.visible = false
    }
  }



  // **********************************************************************
  //
  // METHODS
  //
  // **********************************************************************
  show = ()=> {
    this.mesh.visible = true
  }

  hide = ()=> {
    // this.mesh.visible = false
  }

  startSound = (time = 1)=> {
    for (let key in this.audio) {
      this.audio[key].fadeTo(config.sounds[key].volume, time)
    }
  }

  stopSound = (time = 1)=> {
    for (let key in this.audio) {
      this.audio[key].fadeTo(0, time)
    }
  }
}

export default Tile



// WEBPACK FOOTER //
// ./src/components/game/track-tiled/tile.js